// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const APIVERSION = '/v1';
const APIVERSION_V2 = '/v2';
const API_GATEWAY_URL = '#{apiGatewayUrl}#';
const APIPREFIX='/api';
const APIVERSIONURL= APIPREFIX + APIVERSION;

export const environment = {
  production: '#{production}#',
  isLocal: false,
  SMART_PMO_ACCESS_URL: '#{smartPmoAccessUrl}#',
  BASE_URL: '#{baseUrl}#',
    AIG_URL : '#{aigUrl}#',
    AIG_EU_URL : '#{aigEuUrl}#',
    API_MICROSERVICE_URL: {
    ADMIN : API_GATEWAY_URL + '/admin' + APIVERSIONURL,
    USER : API_GATEWAY_URL + '/user' + APIVERSIONURL,
    METHOD : API_GATEWAY_URL + '/Method' + APIVERSIONURL,
    PACKAGE_CONTENT : API_GATEWAY_URL + '/package-content' + APIVERSIONURL,
    PROJECT : API_GATEWAY_URL + '/Project' + APIVERSIONURL,
    NOTIFICATION : API_GATEWAY_URL + '/notification' + APIVERSIONURL,
    TEST_AI : API_GATEWAY_URL + '/TestAI' + APIVERSIONURL,
    CONTENT_MGMT : API_GATEWAY_URL + '/cms' + APIVERSIONURL,
    INTEGRATIONS : API_GATEWAY_URL + '/Integration' + APIVERSIONURL,
    MATURITY_ASSESSMENT : API_GATEWAY_URL + '/MA' + APIVERSIONURL,
    REPORTING : API_GATEWAY_URL + '/Reporting' + APIVERSIONURL,
    SOCKET_HUB: '#{hubMSBaseUrl}#' + '/hub/notification',
    VERSION:
    {
      V2:
      {
        PROJECT: API_GATEWAY_URL + '/Project' + APIPREFIX + APIVERSION_V2,
      },
    }
  },
  API_BASE_URL: '#{apiBaseUrl}#' + APIPREFIX,
  NOTIFICATION_API_BASE_URL: '#{notificationApiBaseUrl}#' + APIPREFIX,
  MA_API_BASE_URL: '#{maBaseUrl}#' + APIPREFIX,
  CMS_BASE_URL: '#{cmsBaseUrl}#' + APIPREFIX,
  JIRA_BASE_URL: '#{jiraBaseUrl}#',
  JIRA_SAAS_APP_BASE_URL : '#{jiraSaasAppBaseUrl}#',
  GEN_AI_URL: '#{genAIUrl}#',
  AUTONOMOUS_URL:'#{AutonomousUrl}#',
  AUTONOMOUS_CONFIG_URL:'#{AutonomousConfigUrl}#',
  ALM_BASE_URL: '#{almBaseUrl}#',
  AUTO_REPORTING_API_BASE_URL: '#{autoReportingBaseUrl}#'+ APIPREFIX,
  AIP_PLATFORM_ADMIN_URL : '#{aipPlatformAdminUrl}#',
  AIP_PACKAGE_ADMIN_URL : '#{aipPackageAdminUrl}#',
  ALM_PROVISION_URL: '#{almProvisionUrl}#',
  EC_BASE_URL: '#{ecBaseUrl}#',
  SMART_PMO_URL:'#{smartPMOUrl}#',
  ACTIVATION_COACHING_SERVICE_URL: 'https://deloitteus.service-now.com/sp?id=sc_cat_item&sys_id=431f90874f3c2f8cf7a9cf5d0210c761&business_service_sys_id=f0e9b0914ffb170433c77bcd0210c7c6',
  TEST_AI_URL: '#{testAIUrl}#',
  TEST_AI_API : '#{testAIAPIUrl}#',
  SMART_OFFERING_URL:'#{smartOfferingUrl}#',
  ASCEND_AI_API: '#{ascendAiApi}#' + APIPREFIX,
  COOKIE_CONSENT:'#{cookieConsent}#',
  AZURE_CONNECTION : '#{processApiUrl}#',
  APPLICATIONINSIGHTS_CONNECTION_STRING:'#{appInsightsConnectionString}#',
  ASCEND_GO_URL: '#{ascendGoUrl}#',
  ADOBE_ANALYSTICS: '#{adobeAnalytics}#',
  GlOBAL_INSTANCE_DOMAINS: {
    US: '#{usCookieConsentDomain}#',
    EU: '#{euCookieConsentDomain}#',
  },
  ALLOWEDFILEEXTENSIONS: {
    UPLOAD: [ 'xls', 'xlsx', 'doc', 'docx', 'pdf', 'jpg', 'jpeg', 'png', 'ppt', 'pptm', 'pptx', 'zip', 'rtf', 'mpp', 'vsdx', 'xdo', 'xdm', 'catalog', 'xlsm', 'vsd', 'txt', 'pages'],
    VIEW: ['xls', 'xlsx', 'doc', 'docx', 'pdf', 'ppt', 'pptm', 'pptx', 'txt']
  },
  ALLOWEDDOMAINS: ['deloitte', 'deloittece', 'deloittemx','tohmatsu','r8dius'],
  ASCEND_ROADMAP_FILENAME: 'FY22-Ascend Roadmap.pptx',
  CMS_CONTAINER_NAMES: {
    DELIVERABLES: 'use-azs-cms-ascend',
    UTILITY: 'use-azs-utility-ascend',
    PROJECT_WORKSPACE: 'use-azs-project-workspace-ascend'
  },
  AUTO_ON_OFF_USER_CONTAINER: '#{autoOnOffUserContainer}#',
  AUTH_CONFIG: {
    clientID: '#{clientID}#',
    authority: "#{authority}#",
    redirectUri: '#{redirectUri}#',
    cacheLocation: '#{cacheLocation}#',
    postLogoutRedirectUri: "#{postLogoutRedirectUri}#",
    navigateToLoginRequestUrl: false,
    consentScopes: ['#{consentScopes}#', "user.read", "offline_access"],
    unprotectedResources: ["https://www.microsoft.com/en-us/"],
    logger (logLevel, message, piiEnabled){
      return undefined;
    },
    correlationId: '1234',
    piiLoggingEnabled: true
  },
  AUTH_RESOURCE_LINK: {
    self: "https://graph.microsoft.com/v1.0/me",
    users: "https://graph.microsoft.com/v1.0/users",
    graphAll: "https://graph.microsoft.com/v1.0/*",
    webAPI: '#{webAPI}#'
  },

  LOCAL_AUTH: {
    userId: '',
    username: '',
    ssoUser: {
      displayName: '',
      givenName: '',
      jobTitle: '',
      surname: '',
    }
  },
  LOCAL_USERS: [],

  // Phase 5: Session Timeout Configuration
  sessionTimeoutMinutes: "#{sessionTimeoutMinutes}#", // Total inactivity timeout (59 minutes)
  warningBeforeTimeoutMinutes: "#{warningBeforeTimeoutMinutes}#", // Warning shown 1 minute before timeout

  // End

  DESIGNATIONS_LIST: [
    'DC Intern',
    'DC Analyst',
    'DC Product Manager',
    'DC Consultant',
    'DC Senior Consultant',
    'DC Manager',
    'DC Specialist Master',
    'DC Senior Manager',
    'DC Specialist Leader',
    'Managing Director, Consulting',
    'Managing Director',
    'DC Principal',
    'DC Partner',
    'Partner',
    'Principal',
    'External',
    'DC Solution Specialist',
    'DC Solution Analyst',
    'DC Specialist Senior'
  ],
  FILE_SCAN_CONTAINER : "use-azs-cms-ascend-file-scan",
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
